import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import React from 'react';
import {SelectType} from "../../../Types/FormTypes";

const Select = (props: SelectType) => {
    return (
        <div className={`select-wrapper ${props.icon ? 'select-wrapper-icon': ''}`}>
            {props.icon && (
                <div className={'select-wrapper-addon'}>
                    {props.icon}
                </div>
            )}
            <select name={props.name} className={`${props.size ? props.size : ''}`} defaultValue={props.selectedValues ? props.selectedValues[0] : undefined} onChange={props.onChange}>
                {props.placeholder && (
                    <option value={-1}>{props.placeholder}</option>
                )}
                {props.children}
            </select>

            <div className={'select-wrapper-addon select-wrapper-addon-end'}>
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
        </div>
    )
}

export default Select
